import React, { useState, useEffect } from 'react';
import {
    makeStyles, tokens,
    Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions,
    Button, Spinner, Text,
} from '@fluentui/react-components';
import { iconMap } from '../../theme/icons';
import CellItem from '../components/CellItem';
import ItemViewDialog from './ItemViewDialog';
import { API_BASE } from '../../config.js';

const CloseIcon = iconMap.close;

const useStyles = makeStyles({
    surface: { maxWidth: '75rem', width: '100%' },
    // CSS grid + repeat(auto-fit,...) su fiksuoto pločio SelectionBox (type=column,
    // justifySelf:start) palikdavo tuščius grid langelius kaip pilno pločio "tarpus",
    // kai stulpelių daugiau nei realių elementų (žr. /admin/bugs "Ta pati grid
    // problema, nenaudojam grid" — bendra taisyklė visiems dialogams). flex+wrap+gap
    // vietoj grid — kiekvienas elementas užima tik savo turinio plotį.
    grid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    centerBox: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' },
    emptyBox: { padding: tokens.spacingVerticalL, width: '100%', textAlign: 'center' },
    actions: { gap: tokens.spacingHorizontalS },
});

const BasisSelectingDialog = ({
    open,
    onClose,
    onItemSelect,
    selectedLeg
}) => {
    const s = useStyles();
    const [legs, setLegs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [viewingItem, setViewingItem] = useState(null);

    // API užklausa kojelėms gauti
    const fetchLegs = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/legs`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setLegs(data);
        } catch (error) {
            console.error('Klaida gaunant kojelių duomenis:', error);
        } finally {
            setLoading(false);
        }
    };

    // Krauname duomenis tik atidarius dialogą
    useEffect(() => {
        if (open && legs.length === 0) {
            fetchLegs();
        }
    }, [open, legs.length]);

    const getImagePath = (item) => {
        if (!item.image_1 && !item.image) return null;
        const imageName = item.image_1 || item.image;
        try {
            // Nurodome kelią iki kojelių paveikslėlių
            return require(`../../assets/img/legs/${imageName}`);
        } catch (error) {
            // console.warn('Paveikslėlis nerastas:', imageName);
            return null;
        }
    };

    const handleItemSelect = (item) => {
        if (onItemSelect) {
            onItemSelect(item);
        }
        onClose();
    };

    const handleItemView = (item) => {
        setViewingItem(item);
        setViewDialogOpen(true);
    };

    return (
        <>
            <Dialog open={open} onOpenChange={(_e, data) => { if (!data.open) onClose(); }}>
                <DialogSurface id="dialog-basis-selecting" className={s.surface}>
                    <DialogBody>
                        <DialogTitle action={<Button appearance="subtle" icon={<CloseIcon />} aria-label="Uždaryti" onClick={onClose} />}>
                            Pasirinkite kojeles
                        </DialogTitle>
                        <DialogContent>
                            {loading ? (
                                <div className={s.centerBox}>
                                    <Spinner size="large" />
                                </div>
                            ) : (
                                <div className={s.grid}>
                                    {legs.length > 0 ? (
                                        legs.map((leg, index) => {
                                            const imagePath = getImagePath(leg);
                                            return (
                                                <CellItem
                                                    key={leg.id || index}
                                                    image={imagePath}
                                                    title={leg.code}
                                                    subTitle={`Aukštis: ${leg.height}mm`}
                                                    selected={selectedLeg?.id === leg.id}
                                                    onClick={() => handleItemSelect(leg)}
                                                    onView={() => handleItemView(leg)}
                                                />
                                            );
                                        })
                                    ) : (
                                        <div className={s.emptyBox}>
                                            <Text>Kojelių sąrašas tuščias arba nepavyko užkrauti.</Text>
                                        </div>
                                    )}
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions className={s.actions}>
                            <Button size="large" appearance="outline" onClick={onClose}>Uždaryti</Button>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>

            {/* Peržiūros dialogas — kojelės */}
            <ItemViewDialog
                open={viewDialogOpen}
                onClose={() => setViewDialogOpen(false)}
                item={viewingItem}
                itemType="leg"
            />
        </>
    );
};

export default BasisSelectingDialog;
